"use client"

import { LocationId } from "@/data/booking-appointments"
import { MapPin } from "lucide-react"

interface LocationCardProps {
  locationId: LocationId
  locationName: string
  onSelect: () => void
}

/**
 * LocationCard - Selectable card for clinic location
 *
 * Shows clinic name. Pricing is shown in the next step after
 * the user selects their appointment type.
 */
export function LocationCard({
  locationId: _locationId,
  locationName,
  onSelect,
}: LocationCardProps) {
  // _locationId is kept for future use (e.g., location-specific styling)

  return (
    <button
      onClick={onSelect}
      className="w-full p-4 text-left bg-gray-100 border border-gray-200 rounded-xl hover:border-[#848974] hover:bg-gray-50 transition-colors"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <MapPin className="h-5 w-5 text-[#848974] flex-shrink-0" />
          <h3 className="text-base font-normal text-[#3f4141]">{locationName}</h3>
        </div>
        <div className="text-[#848974] font-medium text-sm">
          Select
        </div>
      </div>
    </button>
  )
}
